import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { actions as myProvidersActions } from '../../../redux/appointmentForm/requests/my-providers-req';
import {
  selectMyProvidersCount,
  selectMyProvidersList,
  selectMyProvidersLoading,
  selectMyProvidersPaginationLoading,
  selectProgressCareUserId,
  selectProgressOrganizationId,
} from '../../../redux/appointmentForm/selectors';
import { selectLanguageTypes } from '../../../redux/data/selectors';

const mapStateToProps = state => ({
  userId: selectProgressCareUserId(state),
  loading: selectMyProvidersLoading(state),
  paginationLoading: selectMyProvidersPaginationLoading(state),
  providers: selectMyProvidersList(state),
  organizationId: selectProgressOrganizationId(state),
  languageTypes: selectLanguageTypes(state),
  providersCount: selectMyProvidersCount(state),
});

const mapDispatchToProps = {
  fetchMyProviders: myProvidersActions.send,
  loadMoreMyProviders: myProvidersActions.loadMore,
  initRescheduleFlow: myProvidersActions.selectMyProvider,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentMyProviders/enhance.js